import { Globe, Heart, User, Crown, Plus, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface DemoDashboardProps {
  onSignIn: () => void;
  onUpgrade: () => void;
  isLoggedIn: boolean;
}

export default function DemoDashboard({ onSignIn, onUpgrade, isLoggedIn }: DemoDashboardProps) {
  const action = isLoggedIn ? onUpgrade : onSignIn;
  const actionLabel = isLoggedIn ? "Upgrade" : "Sign In";

  const cards = [
    { icon: <Globe className="w-8 h-8 text-primary" />, label: "Choose Your Nation!" },
    { icon: <Heart className="w-8 h-8 text-primary" />, label: "Choose Your Teams!" },
    { icon: <User className="w-8 h-8 text-primary" />, label: "Choose Your Players!" },
  ];

  return (
    <div className="relative">
      {/* Header */}
      <div className="mb-6 p-4 rounded-xl bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border border-primary/20">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-primary" />
            <div>
              <p className="font-display font-bold text-foreground">
                Build Your Personalized Hockey Hub
              </p>
              <p className="text-sm text-muted-foreground">
                {isLoggedIn ? "Upgrade to Pro/Elite to customize your page." : "Sign in to get started."}
              </p>
            </div>
          </div>
          <Button onClick={action} className="gap-2 shrink-0">
            <Crown className="w-4 h-4" />
            {actionLabel}
          </Button>
        </div>
      </div>

      {/* Empty-state cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {cards.map((card) => (
          <button
            key={card.label}
            onClick={action}
            className="group flex flex-col items-center justify-center gap-3 aspect-square rounded-xl border-2 border-dashed border-border hover:border-primary/50 bg-secondary/30 hover:bg-primary/5 transition-all duration-200 cursor-pointer"
          >
            <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
              {card.icon}
            </div>
            <div className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground group-hover:text-primary transition-colors">
              <Plus className="w-4 h-4" />
              {card.label}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
